<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form class="space-y-16" @submit.prevent="handleSubmit(submitContactListData)">
      <div class="space-y-8">
        <div class="space-y-1">
          <h3 class="text-indigo-500">New List</h3>
        </div>
        <div class="space-y-2">
          <ValidationProvider
            name="name"
            vid="name"
            rules="required"
            v-slot="{ errors, failed }"
            slim
          >
            <BaseFormGroup class="w-full">
              <BaseFormLabel> Name * </BaseFormLabel>
              <BaseFormInput
                ref="name"
                v-model.lazy="contactListData.name"
                v-select
                :disabled="submitting"
                :invalid="failed"
                placeholder="enter list name..."
              />
              <BaseFormInlineMessage v-if="failed" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </ValidationProvider>
        </div>
      </div>
      <div class="space-x-2">
        <BaseButton primary type="submit" :disabled="invalid || submitting">
          <span v-if="!submitting">Submit</span>
          <Loader v-else small inverse />
        </BaseButton>
        <BaseButton ghost type="button" :disabled="submitting" @click="backToContactLists">
          Cancel
        </BaseButton>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'FormCreate',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    contactListData: {
      name: '',
    },
  }),
  methods: {
    submitContactListData() {
      this.$emit('submit', { ...this.contactListData });
    },
    backToContactLists() {
      this.$router.replace({ name: 'accounts.contactLists' });
    },
  },
};
</script>
